import React from 'react'
import PropTypes from 'prop-types'
import MultiSheetCreator from './../../../../components/ExcelCreator/MultiSheetCreator'
import {
  Box,
  Button,
  HStack,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import { useState } from 'react'
import { colors } from '../../../../utils/theme/styles'

export default function ExportEmployees({ fileName }) {
  const [employees, setEmployees] = useState([])
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { sEmpresa } = REPOSITORY.local.company.getUserData()
  const getEmployees = async () => {
    onOpen()
    await REPOSITORY.wsEmpresa.employees
      .getEmployees({
        page: 1,
        limit: 20,
        enterprice: sEmpresa,
        sSucursal: '',
        sCentroCosto: '',
        sGrupo: '',
        sNombre: '',
        sEstado: '',
        sTipoEmpleado: '',
        sRut: '',
        sOrderby: '',
        bAsc: false,
        bOmitirPaginacion: true,
        bReporte: true,
      })
      .then((res) => {
        setEmployees(res.data.cDatosEmpleados)

        onClose()
      })
      .catch((error) => {
        console.error('error', error)

        onClose()
      })
  }
  useEffect(() => {
    getEmployees()
  }, [])

  return (
    <Box h="56px">
      {isOpen ? (
        <HStack backgroundColor={colors.gray[100]} width={'max-content'}>
          <Box h="50px" w="50px" borderRadius={100}>
            <Spinner
              w="100%"
              h="100%"
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
            />
          </Box>
          <Button
            w="328px"
            h="56px"
            target="_blank"
            variant="gray"
            download
            display={'flex'}
            gap={'40px'}
            justifyContent={'flex-start'}
            borderRadius={'0px'}
          >
            <Text variant="body1">Cargando datos de nomina para exportar</Text>
          </Button>
        </HStack>
      ) : (
        <MultiSheetCreator
          filename={fileName}
          data={[employees]}
          sheets={[headers]}
          pageNames={['Colaboradores']}
          label="Exportar vista de nómina"
        />
      )}
    </Box>
  )
}
const headers = [
  { label: 'Cod Empresa (No Modificar)', value: 'sEmpresa' },
  { label: 'Cod Empleado  (No Modificar)', value: 'sEmpleado' },
  { label: 'Nombre', value: 'sNombre' },
  { label: 'Apellido Paterno', value: 'sApellidoPaterno' },
  { label: 'Apellido Materno', value: 'sApellidoMaterno' },
  { label: 'Rut  (No Modificar)', value: 'sRUT' },
  { label: 'Email', value: 'sEMail' },
  { label: 'Estado', value: 'sEstado' },
  { label: 'CentroCosto', value: 'CentroCosto' },
  { label: 'Sucursal', value: 'Sucursal' },
  { label: 'Telefono Movil', value: 'sTelefonoMovil' },
  { label: 'Telefono Fijo', value: 'sTelefonoFijo' },
  { label: 'Fecha Nacimiento (dd-mm-yyyy)', value: 'dNacimiento' },
  { label: 'Sexo (M/F)', value: 'sSexo' },
  { label: 'Cargas Familiares', value: 'sCargasFamiliares' },
  { label: 'Prevision Salud (FON/ISA)', value: 'sPrevisionSalud' },
  { label: 'Grupo', value: 'sGrupo' },
]

ExportEmployees.propTypes = {
  data: PropTypes.array,
  fileName: PropTypes.string,
}
